import React, { useEffect } from 'react'
import { Button } from '@chakra-ui/react'
import NotesList from 'components/MainApp/Notes/NotesList'
import { useLastNoteFromUser, useNotes } from 'hooks/notes'

import 'stylesheets/MainAppStyles/community.css'
import 'stylesheets/Skeletons/LoadingNotes.css'
import { Link, useNavigate } from 'react-router-dom'
import { NEWNOTE } from 'lib/routes'
import { useAuth } from 'hooks/auth'
import { useToast } from '@chakra-ui/react'
import SpinnerLoading from '../Spiners'
import PrimaryButton from 'components/MainComponents/PrimaryButton/PrimaryButton'

const Community = () => {
    const { notes, isLoading: notesLoading } = useNotes();
    const { user, isLoading } = useAuth();
    const { lastNote, isLoading: lastNoteLoading } = useLastNoteFromUser(user?.id)
    const navigate = useNavigate()
    const toast = useToast()


    const handleClickCreateNewNote = () => {
        if (lastNote.length !== 0) {
            const currentDate = new Date();
            const timeDifference = currentDate - lastNote[0].date;
            const timeInMinutes = timeDifference / (1000 * 60);
            const remainingMinutes = 2 - timeInMinutes;

            if (remainingMinutes > 0) {
                toast({
                    title: `Faltan ${remainingMinutes.toFixed(2)} minutos para que se cumplan los dos minutos.`,
                    status: "error",
                    isClosable: true,
                    position: "top",
                    duration: 5000,
                })
            } else {
                navigate(NEWNOTE)
            }
        } else {
            navigate(NEWNOTE)
        }
    }


    return (
        <>
            {(notesLoading || lastNoteLoading || isLoading)
                ? <SpinnerLoading />
                :
                <div className='community-container'>
                    <h2>¿Qué quieres aprender hoy?</h2>
                    <h3>Buena suerte en tu aprendizaje, <span>{user?.name}</span></h3>
                    <PrimaryButton title="Crea una nota" action={handleClickCreateNewNote} icon='ic:baseline-plus'/>
                    {/* <Button onClick={handleClickCreateNewNote} colorScheme='teal'>+ Create a Note</Button> */}
                    <NotesList notes={notes} />
                </div>
            }
        </>
    )
}

export default Community